//********* FILTERS *********//
import * as types from "./actionTypes";

export const setAvailableFilterValues = (availableFilterValues) => ({
  type: types.SET_AVAILABLE_FILTER_VALUES,
  payload: {availableFilterValues}
});

export const updateFiltersCount = () => ({
  type: types.UPDATE_FILTERS_COUNT
})
